import { EnvironmentConfig } from './environment-config.model';

const envBaseUrl = 'lake.tolstunov.pro';

const coreApiBasePath = `https://${envBaseUrl}/backoffice-api`;
const coreApiWsBasePath = `wss://${envBaseUrl}/backoffice-api`;
const houseLpApiBasePath = `https://${envBaseUrl}/house-lp-api`;
const houseLpWsBasePath = `wss://${envBaseUrl}/house-lp-api`;
const fineryMarketsApiBasePath = `https://${envBaseUrl}/finery-api`;
const principalRiskLpApiBasePath = `https://${envBaseUrl}/principal-risk-lp-api`;
const bBookLpApiBasePath = `https://${envBaseUrl}/b-book-lp-api`;
const bBookLpWsBasePath = `wss://${envBaseUrl}/b-book-lp-api`;
const hiddenRoadApiBasePath = `https://${envBaseUrl}/hidden-road-api`;
const mainBookLpApiBasePath = `https://${envBaseUrl}/main-book-lp-api`;
const mainBookLpWsBasePath = `wss://${envBaseUrl}/main-book-lp-api`;
const syntheticLpApiBasePath = `https://${envBaseUrl}/synthetic-lp-api`;
const fireblocksApiBasePath = `https://${envBaseUrl}/fireblocks-api`;
const balancesJugglerApiBasePath = `https://${envBaseUrl}/balances-juggler-api`;
export const environment: EnvironmentConfig = {
  production: false,
  isBermuda: false,
  isQA: false,
  envBaseUrl,
  captchaEnabled: true,
  recaptchaSitekey: '6LdamlYtAAAAAKh9i7YUZGR_BZtCqLT_t-R3taVe',
  googleSsoEnabled: true,
  googleClientId: '302174659507-4mr6p8oundc5ngplrtm8apd6pq211lpo.apps.googleusercontent.com',
  coreApiBasePath,
  coreApiWsBasePath,
  houseLpApiBasePath,
  houseLpWsBasePath,
  fineryMarketsApiBasePath,
  principalRiskLpApiBasePath,
  bBookLpApiBasePath,
  bBookLpWsBasePath,
  hiddenRoadApiBasePath,
  mainBookLpApiBasePath,
  mainBookLpWsBasePath,
  syntheticLpApiBasePath,
  fireblocksApiBasePath,
  balancesJugglerApiBasePath,
};
